import React from "react";
import { AuthorImage, dateFormatter } from "./utils";
import TimeAgo from "react-timeago";
import { formatter } from "../../../isomorphic/utils";
import get from "lodash/get";

export function SingleAuthorTemplate({
  textStory,
  authorNameKeyword,
  storyPubKeyword,
  author = {},
  date,
  showDateOnly = false,
  config = {},
  hideImage = false
}) {
  const authorImage = author["avatar-url"] || author.image;
  const publishKeyword = !showDateOnly && get(config, ["theme-attributes", "lang"] !== "ar") ? "Published on : " : "";
  const getTimeStamp =
    textStory === "photo-low-priority" ? (
      <TimeAgo
        date={date}
        formatter={(value, unit, suffix, date, defaultFormatter) =>
          formatter(value, unit, suffix, date, defaultFormatter, config)
        }
      />
    ) : (
      <TimeAgo
        date={date}
        formatter={(value, unit, suffix, date, defaultFormatter) =>
          dateFormatter(value, unit, suffix, date, defaultFormatter, config)
        }
      />
    );

  return (
    <div className="author">
      {!hideImage && <AuthorImage {...author} />}
      <div className="author__content">
        <h3 className="author__name" data-author-name="true">
          {authorNameKeyword}
          {author.name}
        </h3>
        {date && (
          <div className="author__published-date" data-publish-date="true">
            {storyPubKeyword || (publishKeyword && <span className="pub-keyword">{publishKeyword}</span>)}
            <div className="author__time-stamp-wrapper">{getTimeStamp}</div>
          </div>
        )}
      </div>
    </div>
  );
}
